import React from "react";
import cloneDeep from "lodash/cloneDeep";
import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";
import SpaceBetween from "@cloudscape-design/components/space-between";
import FormField from "@cloudscape-design/components/form-field";
import Modal from "@cloudscape-design/components/modal";
/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { playerModalStore } from "../stores/playerModal";
import { bonusesStore, clientStore, Clientstore } from "../stores/client";
import { bonusesAddModalStore } from "../stores/promotionAddModal";
import { bonusesEditModalStore } from "../stores/promotionEditModal";
import promotionEditModal from "./BonusesEditModal";
import { getRecoil } from "recoil-nexus";
import { playerPageStore } from "../stores/playerPage";
import { fortuneWheelModalStore } from "../stores/fortuneWheelModal";
import { promotionAddModalStore } from "../stores/promotionAddModal";
import { promotionEditModalStore } from "../stores/promotionEditModal";
import { promotionConfigModalStore } from "../stores/promotionConfigModal";
import { clientEditModalStore, providerEditModalStore } from "../stores/clientEditModal";
/* ------- */

class ClientsPage extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.Interface.loadClients();
	}

	handleKeyPress = (event) => {
		if (event.detail.key === "Enter") {
			this.props.setClient({ ...this.props.client, pagination: { ...this.props.client.pagination, current: 1 } });
			setTimeout(() => {
				this.props.Interface.loadClients();
			}, 0);
		}
	};



	render() {


		return (
			<>
				{this.props.client.loaded && this.props.client.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.client.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.client.error.code} | request timestamp: {this.props.client.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}


				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.client.loaded}
					sortingColumn={{ sortingField: this.props.client.sorting.sortingColumn.column }}
					sortingDescending={this.props.client.sorting.isDescending}
					onSortingChange={(sorting) => {
						this.props.setClient({
							...this.props.client,
							sorting: {
								...this.props.client.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? "ASC" : "DESC",
									column: sorting.detail.sortingColumn.sortingField,
								},
								isDescending: sorting.detail.isDescending,
							},
						});
						setTimeout(() => {
							this.props.Interface.loadClients();
						}, 250);
					}}
					columnDefinitions={[
						{
							id: "id",
							header: "ID",
							sortingField: "id",
							cell: (item) => <Button
								iconName={"status-in-progress"}
								className={[this.props.styles["btnUID"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", this.props.styles["blue"]].join(" ")}
								variant="normal"
								onClick={() => {
									setTimeout(() => {
										this.props.setClientEditModal({
											...this.props.clientEditModal,
											show: true,
											id: item.id,
											values: {
												enabledProviders: item.enabledProviders,
											}
										});
									}, 0);
								}}
								children={item.id}
							/>,
						},
						{ id: "name", header: "Name", sortingField: "name", cell: (item) => item.name },
						{ id: "enabledProviders", header: "Enabled Providers", sortingField: "enabledProviders", cell: (item) => item.enabledProviders ?  JSON.parse(item.enabledProviders).length : 0 },
					]}
					items={this.props.client.data}
					preferences={
						<Preferences
							cancelLabel="Cancel"
							confirmLabel="Confirm"
							pageSizePreference={{ title: "Clients per page", options: this.props.config.client.preferences.perPage }}
							preferences={{ pageSize: this.props.config.client.perPage }}
							title="Preferences"
							onConfirm={(preferences) => {
								localStorage.setItem("client.perPage", preferences.detail.pageSize);
								this.props.setConfig({
									...this.props.config,
									client: { ...this.props.config.client, perPage: preferences.detail.pageSize },
								});
								setTimeout(() => {
									this.props.Interface.loadClients();
								}, 250);
							}}
						/>
					}
					header={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Header
									children={`Clients`}
									counter={<>({this.props.client.pagination.count})</>}
								/>
							}
						/>
					}
					pagination={
						<Pagination
							disabled={!this.props.client.loaded}
							currentPageIndex={this.props.client.pagination.current}
							pagesCount={this.props.client.pagination.total}
							onChange={(page) => {
								this.props.setClient({
									...this.props.client,
									pagination: { ...this.props.client.pagination, current: page.detail.currentPageIndex },
								});
								setTimeout(() => {
									this.props.Interface.loadClients();
								}, 250);
							}}
						/>
					}
					empty="No clients found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const client = useRecoilValue(clientStore);
		const setClient = useSetRecoilState(clientStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);

		const clientEditModal = useRecoilValue(clientEditModalStore);
		const setClientEditModal = useSetRecoilState(clientEditModalStore);

		return (
			<Component
				{...props}
				setClientEditModal={setClientEditModal}
				clientEditModal={clientEditModal}
				client={client}
				setClient={setClient}
				config={config}
				setConfig={setConfig}
			/>
		);
	};
}

export default withRecoil(ClientsPage);
